import React, {useEffect} from 'react';
import classNames from 'classnames';
import {
    BackwardIcon,
    ForwardIcon,
    MobilePauseIcon,
    MobilePlayButton
} from '@dazn/lp-web/src/components/Icons';
import styles from '@dazn/lp-web/src/components/VideoBanner/video-banner.module.css';
import {useVideoBannerContext} from '@dazn/lp-web/src/components/VideoBanner/VideoBannerContext';
import {useVideoBannerPlayer} from '@dazn/lp-web/src/components/VideoBanner/useVideoBannerPlayer';

export const VideoMobileControls = () => {
    const {isPlaying, isHovered, setIsHovered} = useVideoBannerContext();
    const {togglePlayPause, handleBackward10Seconds, handleForward10Seconds} =
        useVideoBannerPlayer();

    // Automatically reset `isHovered` to `false` after 3 seconds
    useEffect(() => {
        let timeout: NodeJS.Timeout | null = null;

        if (isHovered) {
            timeout = setTimeout(() => {
                setIsHovered(false);
            }, 3000); // 3 seconds
        }

        // Cleanup timeout on component unmount or when `isHovered` changes
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, [isHovered, setIsHovered]);
    return (
        <div
            className={classNames(styles.mobileVideoControls, styles.zIndex, {
                [styles.visible]: !isPlaying || isHovered
            })}
        >
            <BackwardIcon onClick={handleBackward10Seconds} />
            <div onClick={togglePlayPause}>
                {isPlaying ? <MobilePauseIcon /> : <MobilePlayButton />}
            </div>
            <ForwardIcon onClick={handleForward10Seconds} />
        </div>
    );
};
